import React from "react"

import Layout from "../components/layout"
import Link from "../components/Link"
import Seo from "../components/seo"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const AboutPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Layout location={props.location}>
      <Seo title="About Emento" lang="en-US" pathname="about-emento" />
      <div className="content">
        <div className="grid">
          <div className="g-2col-alt-left about">
            <div className="about-wrapper">
              <div>
                <Breadcrumb
                  crumbs={crumbs}
                  crumbSeparator=" / "
                  crumbLabel={customCrumbLabel}
                />
                <div className="about-preheadline">
                  Well designed and easy-to-use solutions save time and money in
                  the Danish healthcare system
                </div>
                <h1>
                  Emento is a product platform that improves quality for
                  patients and job satisfaction for employees
                </h1>
                <p>
                  Over a number of years, Emento has in collaboration with
                  selected hospitals developed the Digital Process Guide,
                  including the Danish Aarhus University Hospital, which has
                  been voted 3rd best in Europe.
                </p>
                <p>
                  We have completed over 100,000 courses with Emento's Digital
                  Care Guide and we can document that it has a positive effect
                  on the patients.
                </p>
                <p>
                  Today, we have a proven digital tool that thousands of Danes
                  have already used, and that even more will use in the future,
                  since Region Central Jutland has purchased the solution for
                  all its 1.3 million. citizens.
                </p>
              </div>
              <div className="about-statement">
                <div className="about-statement-quote-wrapper">
                  <div className="about-statement-quote grey">
                    "With the messaging function, we know if we need to see
                    patients for an emergency check-up or we can leave them out.
                    So that can save us some consultations. I think it works
                    really well."
                  </div>
                  <div className="about-statement-title">
                    <h4>Line Holm Jensen</h4>
                    <div>Nurse</div>
                    <div>Clinic for Children and Adolescents</div>
                    <div>Aarhus University Hospital, Denmark</div>
                  </div>
                </div>
                <div className="about-statement-portrait-wrapper">
                  <div className="about-statement-portrait">
                    <img
                      src="/images/landing_pages/esundhed/statement-portrait-line-holm.png"
                      alt="Line Holm Jensen"
                    />
                  </div>
                </div>
              </div>
              <div className="space-4" />
              <div>
                <h3>Positive economic impact</h3>
                <p>
                  When patients use the care guide from Emento, communication
                  between patients and healthcare providers improves.
                </p>
                <p>
                  For the patient, this means that patient satisfaction
                  increases and that the patient takes more responsibility for
                  their own care.
                </p>
                <p>
                  For the practitioners, the digital care guide means that they
                  have more time for the patients, which has a positive impact
                  on job satisfaction.
                </p>
                <p>
                  For hospitals, there is a direct economic, positive effect
                  when hospitalization time decreases.
                </p>
              </div>

              <div className="about-statement">
                <div className="about-statement-quote-wrapper">
                  <div className="about-statement-quote grey">
                    "This means that we can get a slightly larger flow of
                    patients. We can get them discharged a little faster,
                    because they feel comfortable coming home. And that means
                    that you don't have such a stomach ache when you send people
                    home."
                  </div>
                  <div className="about-statement-title">
                    <h4>Stinne Koudahl</h4>
                    <div>Nurse</div>
                    <div>Gastrointestinal surgery</div>
                    <div>Aarhus University Hospital, Denmark</div>
                  </div>
                </div>
                <div className="about-statement-portrait-wrapper">
                  <div className="about-statement-portrait">
                    <img
                      src="/images/landing_pages/esundhed/statement-portrait-stinne.png"
                      alt="Stinne Koudahl"
                    />
                  </div>
                </div>
              </div>
              <div className="about-statement">
                <div className="about-statement-quote-wrapper">
                  <div className="about-statement-quote grey">
                    "We can see from the patients that they are using the app
                    more and more, so we can save some time, and maybe even more
                    in the future, on providing information. We see that it
                    works just like before, and that is also the intention, but
                    the time spent is less."
                  </div>
                  <div className="about-statement-title">
                    <h4>Torben Smidt Hansen</h4>
                    <div>Department physician</div>
                    <div>Lung diseases</div>
                    <div>Aarhus University Hospital, Denmark</div>
                  </div>
                </div>
                <div className="about-statement-portrait-wrapper">
                  <div className="about-statement-portrait">
                    <img
                      src="/images/landing_pages/esundhed/statement-portrait-torben.png"
                      alt="Torben Smidt Hansen"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="g-2col-alt-right">
            <div className="about-facts">
              <div className="about-box">
                <div className="about-icon">
                  <img src="/svg/icons/emento_bed_icon.svg" alt="bed icon" />
                </div>
                <div className="about-box-body">
                  At Aarhus University Hospital, the occupancy rate decreased
                  from <span className="emph">2,7 to 2,5</span> days in the
                  family wards and from <span className="emph">3,5 to 3,2</span>{" "}
                  in the mother/child ward.
                </div>
                <div className="about-box-source">
                  (Source: Digital Patient Guide to Maternity Care, 2019, Aarhus
                  University Hospital)
                </div>
              </div>
              <div className="about-box">
                <div className="about-icon">
                  <img
                    src="/svg/icons/emento_hospital_icon.svg"
                    alt="bed icon"
                  />
                </div>
                <div className="about-box-body">
                  At Slagelse Hospital, the average overshoot of the standard
                  hospitalization time for bowel patients decreased from{" "}
                  <span className="emph">2,2 days in 2019 to 1,2 in 2020</span>.
                  The results were even more convincing for rectum patients, who
                  were previously admitted for{" "}
                  <span className="emph">2,9 days in 2019</span>, but with a
                  better patient pathway were only admitted for{" "}
                  <span className="emph">0,44 days in 2020</span>.
                </div>
                <div className="about-box-source">
                  (Source: Patient engagement via app, Slagelse Hospital, 2021)
                </div>
              </div>
              <div className="about-box">
                <div className="about-icon">
                  <img src="/svg/icons/emento_like_icon.svg" alt="bed icon" />
                </div>
                <div className="about-box-body">
                  Patient satisfaction at Nordsjællands Hospital increased to
                  above the national average in the Department of Orthopaedic
                  Surgery. Previously, it was <span className="emph">4,19</span>{" "}
                  - well below the national average of 4,35. After Nordsjællands
                  Hospital introduced the digital care guide, satisfaction
                  increased to <span className="emph">4,62</span> - i.e. higher
                  than the national average.
                </div>
                <div className="about-box-source">
                  (Source: Capital Region of Denmark, 2020)
                </div>
              </div>
              <div className="about-box">
                <div className="about-icon">
                  <img
                    src="/svg/icons/emento_hospital_icon.svg"
                    alt="bed icon"
                  />
                </div>
                <div className="about-box-body">
                  At the Department of Heart, Lung and Cardiac Surgery at Aarhus
                  University Hospital, both patients and practitioners waited
                  less time. Communication between the department and the
                  patient became much more efficient by using the digital care
                  guide. The patient previously spent more than{" "}
                  <span className="emph">
                    3 hours in the department, and after implementing the guide,
                    30 minutes.
                  </span>
                  . For the ward, the figure was{" "}
                  <span className="emph">
                    45 minutes before and 15 minutes after
                  </span>
                  .
                </div>
                <div className="about-box-source">
                  (Source: Aarhus University Hospital, 2018)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="about-team-link">
          <Link to="/team">
            Read more about Emento's growing team here &gt;&gt;
          </Link>
        </div>
      </div>

      <div className="content-wide about-team">
        <Link to="/team" alt="emento team">
          <img
            src="/images/team/ementodk_group_shot.jpg"
            alt="emento DK 2022"
          />
        </Link>
      </div>
    </Layout>
  )
}

export default AboutPage
